/* External dependencies */
import { filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { Warehouse } from '../../types';
import { getWarehouseError, getWarehouseSuccess } from './action';
import { getWarehouseQuery } from './queries';
import { GetWarehouseAction, GetWarehouseActionTypes, GetWarehouseRequest } from './types';

export default function getWarehouseEpic(action$) {
  return action$.pipe(
    filter((action: GetWarehouseAction) => action.type === GetWarehouseActionTypes.GET_WAREHOUSE),
    switchMap((action: GetWarehouseRequest) =>
      getWarehouse(action)
        .then(getWarehouseSuccess)
        .catch((error: Error) => getWarehouseError(error)),
    ),
  );
}

export async function getWarehouse(action: GetWarehouseRequest): Promise<Warehouse> {
  const { warehouseId } = action;

  const graphQLClient = await getClient();
  const variables = { input: { id: warehouseId } };

  const {
    data: { getWarehouse },
  } = await graphQLClient.query({
    query: getWarehouseQuery,
    variables,
  });

  return getWarehouse;
}
